export default __webpack_public_path__ + "static/media/doc.b0d02c39.png";